import { Button } from '../../../../../components/button/button';
import { Card } from '../../../../../components/card/card';
import { Page } from '../../../../../components/page/page';
import s from './create-device-qr.module.css';
import { DeviceQrSettings } from './device-qr-settings/device-qr-settings';
import { useCreateDeviceQr } from './use-create-device-qr';

export const CreateDeviceQr = () => {
  const { handleNext, isLoading, id, t } = useCreateDeviceQr();

  return (
    <Page className={s.page}>
      <h2 className={s.title}>
        {t(id ? 'Изменить авторизационный QR-код' : 'Создать авторизационный QR-код')}
      </h2>
      <Card className={s.container} title={t('Настройка')} withLang>
        <DeviceQrSettings />
        <div className={s.controls}>
          <Button variant="secondary" hrefBack disabled={isLoading} data-testid="back-button">
            {t('Назад')}
          </Button>
          <Button
            variant="primary"
            onClick={handleNext}
            disabled={isLoading}
            data-testid="submit-button"
          >
            {t(id ? 'Изменить' : 'Создать')}
          </Button>
        </div>
      </Card>
    </Page>
  );
};
